export const relationId = value => String(value && typeof value === 'object' ? value.id : value)

export const isIncompleteOrder = order => order &&
  (order.completed === false ||
    order.completed === 0 ||
    order.completed === '0' ||
    order.completed === null ||
    order.completed === undefined)

export const orderDate = (order) => {
  if (!order || !order.run_date) {
    return null
  }

  return new Date(`${order.run_date} ${order.run_time || '00:00:00'}`)
}

export const numericOrderField = (order, field) => {
  if (!order || order[field] === null || order[field] === undefined || order[field] === '') {
    return null
  }

  const value = Number(order[field])
  return Number.isFinite(value) ? value : null
}

export const orderCfsEffect = (order, baseCfs) => {
  const original = numericOrderField(order, 'original_cfs')
  const newCfs = numericOrderField(order, 'new_cfs')
  const netCfs = numericOrderField(order, 'net_cfs')

  if (original !== null && newCfs !== null && netCfs !== null) {
    return {
      original_cfs: original,
      new_cfs: newCfs,
      net_cfs: netCfs
    }
  }

  const flow = Number(order.flow) || 0
  let legacyOriginal = baseCfs
  let legacyNew = baseCfs

  if (order.type === 'On') {
    legacyOriginal = 0
    legacyNew = flow
  } else if (order.type === 'Off') {
    legacyOriginal = baseCfs > 0 ? baseCfs : Math.abs(flow)
    legacyNew = 0
  } else if (order.type === 'Increase' || order.type === 'Decrease') {
    legacyNew = flow
  }

  return {
    original_cfs: legacyOriginal,
    new_cfs: legacyNew,
    net_cfs: legacyNew - legacyOriginal
  }
}

export const projectedCfsAtOrderTime = ({
  order,
  orders = [],
  currentCfs = 0
}) => {
  if (!order || !order.diversionPoint) {
    return 0
  }

  const targetDate = orderDate(order)
  if (!targetDate || Number.isNaN(targetDate.getTime())) {
    return Number(currentCfs) || 0
  }

  const targetDiversionPointId = relationId(order.diversionPoint)
  const targetOrderId = order.id === null || order.id === undefined ? null : String(order.id)

  return orders
    .filter(scheduledOrder => isIncompleteOrder(scheduledOrder))
    .filter(scheduledOrder => relationId(scheduledOrder.diversionPoint) === targetDiversionPointId)
    .filter(scheduledOrder => targetOrderId === null || String(scheduledOrder.id) !== targetOrderId)
    .filter((scheduledOrder) => {
      const scheduledDate = orderDate(scheduledOrder)
      return scheduledDate && !Number.isNaN(scheduledDate.getTime()) && scheduledDate < targetDate
    })
    .sort((a, b) => {
      const dateCompare = orderDate(a) - orderDate(b)
      if (dateCompare !== 0) {
        return dateCompare
      }

      return Number(a.id || 0) - Number(b.id || 0)
    })
    .reduce((runningCfs, scheduledOrder) => {
      return orderCfsEffect(scheduledOrder, runningCfs).new_cfs
    }, Number(currentCfs) || 0)
}
